// @flow

import styled from 'styled-components';
import React from 'react';
import type { Theme } from '../../../types';
import { zIndexMap } from '../../../helpers';
import { SEMIBOLD } from '../../../helpers/fontWeight';


const Pill = styled<any, Theme>('span')`
  align-items: center;
  background-color: ${props => props.theme.carblock.capsule.backgroundColor};
  border-radius: 1.25rem;
  color: ${props => props.theme.carblock.capsule.color};
  display: flex;
  font-weight: ${SEMIBOLD};
  font-size: ${props => props.theme.carblock.capsule.fontSize};
  height: 2.5rem;
  justify-content: center;
  padding: 0 2rem;
`;

const Overlay = styled<any, Theme>('section')`
  align-items: center;
  background-color: hsla(0, 0%, 95%, .8);
  border-radius: ${props => props.theme.carblock.borderRadius};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: ${zIndexMap.carblockNotAvailableOverlay};
`;

type Props = {
  overlayText: string,
};

const CarBlockOverlay = ({ overlayText }: Props) => (
  <Overlay>
    <Pill>{overlayText}</Pill>
  </Overlay>
);

export default CarBlockOverlay;
